export const FEEDING_SCREEN = "#/feeding";
export const VIDEO_SCREEN = "#/video";

const SHELL_BASEPATHS = /^(marlin-v2|tide)\//;

const TRANSIENT_SCREEN_TYPES = [
  "#/login",
  "#/logout",
  "#/access-denied",
  "#/not-found",
];

export const normalizeScreenType = (screenType: string | undefined): string => {
  const raw = (screenType ?? "").trim();
  if (!raw) {
    return "";
  }
  const withoutHash = raw.startsWith("#") ? raw.slice(1) : raw;
  const withoutLeadingSlash = withoutHash.replace(/^\/+/, "");
  const withoutBasepath = withoutLeadingSlash.replace(SHELL_BASEPATHS, "");
  const firstSegment = withoutBasepath.split(/[/?#]/)[0];
  return firstSegment ? `#/${firstSegment}` : "";
};

const RETIRED_SCREEN_TYPES: Record<string, string> = {
  "#/calibrate-screens": "marlin-v2/video",
};

export const replaceRetiredScreenType = (screenType: string): string =>
  RETIRED_SCREEN_TYPES[normalizeScreenType(screenType)] ?? screenType;

export const isTransientScreenType = (
  screenType: string | undefined,
): boolean =>
  TRANSIENT_SCREEN_TYPES.includes(
    normalizeScreenType(screenType).toLowerCase(),
  );

export const extractScreenTypeFromUrl = (
  navigationUrl: string | undefined,
): string | undefined => {
  if (!navigationUrl) {
    return undefined;
  }
  let url: URL;
  try {
    url = new URL(navigationUrl);
  } catch {
    return undefined;
  }
  const hashRoute = url.hash.split("?")[0];
  const pathRoute = url.pathname.replace(/^\/+/, "").split("?")[0];
  if (isTransientScreenType(hashRoute) || isTransientScreenType(pathRoute)) {
    return undefined;
  }
  // MFE-shell routes carry the canonical route in the PATHNAME
  // ("/marlin-v2/video"), alongside a mirror hash ("#/marlin-v2/video").
  // single-spa only activates an MFE when the *reopened* URL's pathname
  // starts with its basepath, so the pathname form must be persisted —
  // storing the hash reopens with pathname "/", leaving the shell on the
  // default welcome screen. Prefer the pathname; fall back to the hash for
  // the legacy monolith-tide HashRouter (served from "/", route lives only
  // in "#/video").
  const candidate = pathRoute || hashRoute;
  if (!candidate || candidate === "/") {
    return undefined;
  }
  return candidate;
};

export const isFeedingScreen = (screenType: string | undefined): boolean =>
  normalizeScreenType(screenType) === FEEDING_SCREEN;

export const isVideoScreen = (screenType: string | undefined): boolean =>
  normalizeScreenType(screenType) === VIDEO_SCREEN;
